<script>
import lazyLoadComponent from '@router/lazyload-component'
import BaseInputFloatingLabel from '@components/BaseInputFloatingLabel'
import draggable from 'vuedraggable'
const initData = {
  canAutoRenew: 0,
  title: '',
  size: 1,
  introtext: '',
  description: '',
}
export default {
  components: { BaseInputFloatingLabel, draggable },
  data() {
    return {
      dialog: false,
      drag: false,
      activeLight: '',
      list: [],
      submitData: Object.assign({}, initData),
      isActiveDragging: false,
      tryingToStoreLight: false,
    }
  },
  computed: {
    productId() {
      return this.$route.params.productId
    },
    productType() {
      return this.$route.params.product.type
    },
    isEditMode() {
      return this.submitData.id !== undefined
    },
    submitRules() {
      return {
        title: [
          {
            required: true,
            trigger: 'blur',
            message: '請輸入燈種名稱',
          },
        ],
        introtext: [
          {
            required: true,
            trigger: 'blur',
            message: '請輸入放置地點',
          },
        ],
        description: [
          {
            required: true,
            trigger: 'blur',
            message: '請輸入燈種說明',
          },
        ],
      }
    },
  },
  created() {
    this.tryToFetchLight(true)
  },
  methods: {
    async tryToFetchLight(emit = false) {
      this.list = await this.$store.dispatch('product/fetchLight', this.productId)
      if (this.list.length) {
        // this.$emit('show-light-setting')
        if (emit) {
          this.$emit('update-light', this.list[0])
          this.$emit('show-light-setting')
          this.activeLight = this.list[0].id
        } else if (!this.isEditMode) {
          this.$emit('update-light', this.list[this.list.length - 1])
          this.$emit('show-light-setting')
          this.activeLight = this.list[this.list.length - 1].id
        }
        this.$emit('get-light-settings')
      }
    },
    async tryToStoreLight() {
      this.tryingToStoreLight = true
      await this.$store.dispatch('product/storeLight', { submitData: this.submitData, productId: this.productId })

      this.tryToFetchLight()
      this.dialog = false
      this.tryingToStoreLight = false
    },
    async tryToSortLight(id, indexDiff) {
      if (indexDiff === 0) return
      await this.$store.dispatch('product/sortLight', { submitData: { id, indexDiff }, productId: this.productId })
    },
    editCurrentLight(item) {
      this.submitData = Object.assign({}, item)
      this.dialog = true
    },
    updateActiveLight(item, index) {
      this.$emit('update-light', item)
      this.$emit('show-light-setting')
      this.activeLight = item.id
    },
    onStart(params) {
      this.darg = true
    },
    onEnd(params) {
      this.darg = false
      this.tryToSortLight(this.list[params.newIndex].id, params.newIndex - params.oldIndex)
    },
    onDialogClose() {
      this.submitData = Object.assign({}, initData)
      this.$refs.form.resetFields()
    },
    onClickStore() {
      this.$refs.form.validate((valid) => {
        if (valid) this.tryToStoreLight()
      })
    },
    mergeList(lightSettings) {
      if (lightSettings.length) {
        this.list.forEach((item, index) => {
          lightSettings.some((setting) => {
            if (item.id === setting.itemId) {
              this.$set(this.list, index, {
                ...item,
                state: setting.state,
              })
              return true
            }
            return false
          })
        })
      } else {
        this.list.forEach((item, index) => {
          this.$set(this.list, index, {
            ...item,
            state: undefined,
          })
        })
      }
    },
  },
}
</script>

<template>
  <div>
    <div :class="$style.header">
      <el-button style="width:100%;" type="primary" plain @click="dialog = true"><BaseIcon name="plus" /> 新增燈種</el-button>
    </div>

    <div :class="$style.list">
      <draggable v-model="list" animation="200" handle=".handle-subject" @start="onStart" @end="onEnd">
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <div v-for="(item, index) in list" :key="`year-${index}`" :class="[$style.item, item.id === activeLight ? $style.active : '']" @click.self="updateActiveLight(item, index)">
            <span style="display: flex;align-items: center;" @click.self="updateActiveLight(item, index)">
              <BaseIcon name="grip-vertical" icon-style="fas" :class="[$style.drag, 'handle-subject']" />
              <span v-if="item.state !== undefined" :class="[$style.label, item.state ? $style.open : $style.close]" @click.self="updateActiveLight(item, index)">{{
                item.state ? '販售' : '停售'
              }}</span>
              <span @click.self="updateActiveLight(item, index)">{{ item.title }}</span>
            </span>
            <el-tooltip content="編輯燈種" placement="top">
              <el-button v-show="item.id === activeLight" plain @click="editCurrentLight(item)"><BaseIcon name="edit"/></el-button>
            </el-tooltip>
          </div>
        </transition-group>
      </draggable>
    </div>

    <el-dialog :title="isEditMode ? '編輯燈種' : '新增燈種'" :visible.sync="dialog" width="500px" top="0" append-to-body @close="onDialogClose">
      <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form--floating" style="margin-top:20px;">
        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item label="燈種名稱" prop="title">
              <BaseInputFloatingLabel v-model="submitData.title" />
            </el-form-item>
          </el-col>
          <el-col v-show="productType === 'light'" :span="8">
            <!-- 禮斗不能續燈 -->
            <el-form-item label="開放隔年自動續燈" prop="canAutoRenew">
              <el-switch v-model="submitData.canAutoRenew" active-text="開" inactive-text="關" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="放置地點" prop="introtext"> <BaseInputFloatingLabel v-model="submitData.introtext"/></el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="說明" prop="description"><BaseInputFloatingLabel v-model="submitData.description" /> </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div :class="$style.footer">
        <el-button plain @click="dialog = false">取消</el-button>
        <el-button :loading="tryingToStoreLight" :disabled="tryingToStoreLight" type="primary" @click="onClickStore">
          <BaseIcon name="check" />
          <span>{{ isEditMode ? '編輯' : '建立' }}</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" module>
.header {
  padding: 15px;
  border: 1px solid rgba(211, 211, 211, 0.4);
  border-top: none;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  height: 50px;
  border-bottom: 1px solid rgba(211, 211, 211, 0.4);
  border-top: none;
  &.active {
    background-color: #f2ac57;
    color: white;
    border: none;
    :global {
      button {
        background-color: #f2ac57 !important;
        color: white !important;
        padding: 17px;
        padding-right: 8px;
        border: none;
        font-size: 16px;
      }
    }
    .drag {
      color: white;
    }
  }
  .drag {
    color: lightgray;
    font-size: 28px;
    padding: 7px 9px 7px 0;
    margin-right: -0.3em;
    margin-left: -0.1em;
  }
  .label {
    color: white;
    border-radius: 8px;
    font-size: 12px;
    padding: 4px 6px 4px 10px;
    letter-spacing: 2px;
    font-weight: 400;
    margin-right: 12px;
    &.open {
      background-color: #6aad48;
    }
    &.close {
      background-color: #f85858;
    }
  }
}
.list {
  overflow: auto;
  height: 345px;
  border: 1px solid rgba(211, 211, 211, 0.4);
  border-top: none;
}

.footer {
  padding-bottom: 15px;
  text-align: center;
  :global {
    button {
      width: 160px;
    }
  }
}
.drag {
  color: lightgray;
  width: 100%;
}
</style>
